app = angular.module('harriApp');
app.controller('mediaViewerController',
    ['$scope', '$compile', '$timeout','$stateParams','$state',
        function ($scope, $compile, $timeout, $stateParams, $state) {
            var $id =  $stateParams['id'];
            //$('#'+$id).trigger('click');


}]);